import { SupportChatSeller } from '../../types'
import { ZendeskFieldIds } from './config'

export const buildZendeskContextFields = (
  seller: SupportChatSeller,
  fieldIds: ZendeskFieldIds
) =>
  [
    { id: fieldIds.document, value: seller.document ?? '' },
    { id: fieldIds.sellerId, value: String(seller.id ?? '') },
    { id: fieldIds.sellerName, value: seller.name ?? '' },
    { id: fieldIds.city, value: seller.address?.city ?? '' },
  ].filter(field => field.id && field.value)
